import _ from 'lodash';
import compString from '../../utils/compString';
import Input from '../../views/InputBouncy';
import WeightWidget from '../../views/WeightWidget';
import ListEditor from '../../views/ListEditor';
import React from 'react';

const keywordInputStyle = {
  width: '100%',
};

const OFFSET = 10000;
const ROW_OFFSET = 10;

export default (bottle) => {
  bottle.factory('terminusDrilldownColumns', () => ({
    setTerm, setTermWeight, setSoundsLike, size,
  }) => [
    {
      title: 'Term',
      dataIndex: 'term',
      sortDirections: ['ascend'],
      sorter: (vocA, vocB) => compString(
        _.get(vocA, 'term', ''),
        _.get(vocB, 'term', ''),
        true,
      ),
      width: size === 'small' ? 200 : 350,
      render: (term, row, index) => (
        <Input
          style={keywordInputStyle}
          tabIndex={(index * ROW_OFFSET) + OFFSET}
          onChange={(event) => {
            setTerm({
              term: event.target.value,
              id: row.id,
            });
          }}
          value={term}
        />
      ),
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      width: 150,
      render(weight, row, index) {
        return (<WeightWidget
          term={_.get(row, 'term', '')}
          weight={weight}
          onChange={weight => setTermWeight({ id: row.id, weight })}
          empty={row.empty}
          tabIndex={(index * ROW_OFFSET) + OFFSET + 1}
        />);
      },
    },
    {
      title: 'Sounds Like',
      dataIndex: 'soundsLike',
      // eslint-disable-next-line max-len
      render: (soundsLike, row) => (
        <ListEditor
          list={soundsLike}
          term={row.term}
          empty={row.empty}
          size={size}
          onChange={phrases => setSoundsLike({ id: row.id, soundsLike: phrases })}
        />
      ),
    },
  ]);
};
